import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BarChartComponent } from '../../../my-shared-lib/src/lib/chart-components/bar-chart/bar-chart.component';
import { AuthGuard } from './shared/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'pricing-report',
    pathMatch: 'full',
  },
  {
    path: 'example-dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'example.json' },
  },
  {
    path: 'opportunity-overview',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'opprtunity-overview.json' },
  },
  {
    path: 'pricing-report',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'pricing-report.json' },
  },
  {
    path: 'Process-Progress',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'view.json' },
  },
    {
    path: '**',
    redirectTo: 'pricing-report',
  },
];
